import { type MenuItem } from '@databases/contextual-menu';

import { SELECT_VALUE_MENU_ACTIONS } from '../types';

import { type MenuItemMap } from './create-contextual-menu-items';

/**
 * Defines the ordered list of items as they should appear in the first
 * group of the menu items.
 */
const firstMenuItems: SELECT_VALUE_MENU_ACTIONS[] = [SELECT_VALUE_MENU_ACTIONS.ASK_ROVO];

/**
 * Defines the ordered list of items as they should appear in the second
 * group of the menu items.
 */
const secondMenuItems: SELECT_VALUE_MENU_ACTIONS[] = [
  SELECT_VALUE_MENU_ACTIONS.COMMENTS,
  SELECT_VALUE_MENU_ACTIONS.COPY_VALUE_LINK,
  SELECT_VALUE_MENU_ACTIONS.BULK_EDIT_VALUES,
];

/**
 * Defines the ordered list of items as they should appear in the third
 * group of the menu items.
 */
const thirdMenuItems: SELECT_VALUE_MENU_ACTIONS[] = [
  SELECT_VALUE_MENU_ACTIONS.ADD_FIELD_RIGHT,
  SELECT_VALUE_MENU_ACTIONS.ADD_ENTRY_BELOW,
  SELECT_VALUE_MENU_ACTIONS.CLEAR_VALUES,
  SELECT_VALUE_MENU_ACTIONS.DELETE_ENTRIES,
  SELECT_VALUE_MENU_ACTIONS.DELETE_FIELDS,
];

/**
 * Groups the given flat list of menu items in to
 * three lists as defined above.
 */
export function groupMenuItemsInOrder(menuItems: MenuItemMap): {
  items: MenuItem[];
}[] {
  return [
    {
      items: firstMenuItems
        .map((item) => {
          if (item in menuItems) {
            return menuItems[item];
          }
        })
        .filter(Boolean) as MenuItem[],
    },
    {
      items: secondMenuItems
        .map((item) => {
          if (item in menuItems) {
            return menuItems[item];
          }
        })
        .filter(Boolean) as MenuItem[],
    },
    {
      items: thirdMenuItems
        .map((item) => {
          if (item in menuItems) {
            return menuItems[item];
          }
        })
        .filter(Boolean) as MenuItem[],
    },
  ];
}
